import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { PropRoute } from '../routes/PropRoute'
// Assets for header
import bigSVG from '../assets/images/header-bg-large.svg'
import smallSVG from '../assets/images/header-bg.svg'

// Routes
import { rootLinks } from '../assets/data/menu'

// Components
import { Grid } from '@softwaredev_cegeka/stix-core'
import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { Dashboard } from './index'
import { EditArticle } from './index'

/**
 * Render Routes
 * Caution: be sure to render sub routes before root routes, because when a sub
 * route is detected, and the root route is in code before the sub route, there
 * will be a match and the root route will be loaded instead of the sub route.
 */
// TODO change new route to normal route when api calls are prefixed.
class Main extends React.Component {
    // TODO: Refactor this to a proper "routes" file.
    //  This has too much complexity for something as simple as routing.
    renderRoutes(dataSource, rootPath = '/') {
        return dataSource
            .filter(item => {
                // We only want to create routes for paths that are
                // - Have a path
                // - not absolute (those should be handled by rootPaths)
                // - have a component to show.
                return item.path && item.component && !item.path.startsWith('/')
            })
            .map((item, index) => {
                return (
                    <PropRoute
                        key={index}
                        exact
                        path={`${rootPath}${item.path}`}
                        match={this.props.match}
                        data={item}
                        component={item.component}
                    />
                )
            })
    }

    render() {
        return (
            <Router>
                <Header userData={this.props.userData} />
                <div className={'header-bg-container'}>
                    <div
                        style={{ backgroundImage: `url(${bigSVG})` }}
                        className={'header-big-svg'}
                    />
                    <div className={'header-small-svg'}>
                        <img src={smallSVG} alt={''} />
                    </div>
                </div>
                <Grid.Container className={'page-body'}>
                    <Switch>
                        <Route exact path={'/'} component={Dashboard} />
                        {this.renderRoutes(rootLinks)}
                        <PropRoute
                            data={{ name: 'Edit article' }}
                            path={'/articles/edit/:id'}
                            component={EditArticle}
                        />
                    </Switch>
                </Grid.Container>
                <Footer />
            </Router>
        )
    }
}

export default Main
